import * as React from 'react';
import {useEffect, useRef, useState} from "react";
import {usePdf} from "@mikecousins/react-pdf";
import {PDFDocumentProxy} from "pdfjs-dist";
import {EsignDocument} from "../../types";
import ExportPdfPage from "../ExportPdfPage";

type ExportPdfDocumentParams = {
    ed: EsignDocument
}

const ExportPdfDocument: React.FunctionComponent<ExportPdfDocumentParams> = (p) => {

    const [page, setPage] = useState(0);
    const [documentProxy, setDocumentProxy] = useState<PDFDocumentProxy>();
    const canvasRef = useRef<HTMLCanvasElement>(null);


    const {pdfDocument, pdfPage} = usePdf({
        file: p.ed.template.url,
        page,
        canvasRef,
        scale: 1.5,
        onDocumentLoadSuccess: (document:PDFDocumentProxy) => {
            setDocumentProxy(document);
        }
    })

    const elements = [];
    if (document !== undefined && documentProxy !== undefined) {
        for (let i = 1; i <= documentProxy?.numPages; i++) {
            const fields = p.ed.fields.filter((f) => f.page === i);
            elements.push(<div key={Math.random()+"_"}>
                <ExportPdfPage page={i} document={documentProxy} fields={fields} />
                </div>
            );

        }
    }
    return (<>
        {elements}
    </>);
};

export default ExportPdfDocument;